import React from 'react';

interface Props {
    recallErrorMsg: string;
    invalidVinError: boolean;
}

export const RecallsApiErrorMessage = (props: Props) => {
    return (
        <>
            {props.recallErrorMsg && (
                <div
                    className={`"error-msg" ${
                        props.invalidVinError ? 'invalid-vin' : ''
                    }`}
                    data-testid="error-msg-recalls"
                    id="error-msg-recalls"
                >
                    {props.recallErrorMsg}
                </div>
            )}
        </>
    );
};
